<div class="fnld-top">
  <h2>Latest from uReport</h2>
  <button type="button" class="fnld-close" (click)="close()" aria-label="Close dialog">
    <span class="material-icons">close</span>
  </button>
</div>
<div class="fnld-source" *ngIf="data.sourceName"><i></i>{{ data.sourceName }} news source</div>
<app-fan-news-card design="popup" [stories]="data.stories"></app-fan-news-card>
